export default __webpack_public_path__ + "static/media/check-list.43704b89.svg";